"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgLtLogo = function SvgLtLogo(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.056 30c0 16.566-13.434 30-30 30-16.566 0-30-13.434-30-30 0-16.566 13.434-30 30-30 16.565 0 30 13.434 30 30Z",
    fill: "url(#lt-logo_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.972 12.097c-8.852 0-16.018 7.186-16.018 16.032 0 1.047.084 1.661.084 1.661.112.754.822 1.381 1.59 1.381h28.675c.767 0 1.478-.627 1.59-1.381 0 0 .083-.628.083-1.66.014-8.861-7.152-16.033-16.004-16.033Z",
    fill: "#FCEE21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.834 35.358c0 .837-.752 1.535-1.672 1.535H8.643c-.92 0-1.673-.698-1.673-1.535 0-.838.753-1.535 1.673-1.535h42.519c.92 0 1.672.697 1.672 1.535Zm-6.273 5.86c0 .851-.752 1.535-1.673 1.535H14.916c-.92 0-1.673-.684-1.673-1.535 0-.851.753-1.535 1.673-1.535h29.972c.92 0 1.673.684 1.673 1.535Zm-7.528 5.861c0 .851-.752 1.535-1.672 1.535H22.444c-.92 0-1.673-.684-1.673-1.535 0-.851.753-1.535 1.673-1.535h14.917c.92 0 1.672.684 1.672 1.535Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lt-logo_svg__a",
    x1: 0.061,
    y1: 59.995,
    x2: 0.061,
    y2: 0.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D7FF"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgLtLogo);
var _default = exports["default"] = Memo;